import React from 'react';
import PropTypes from 'prop-types';

import Prompt from '../Prompt';

import sessionReader from '../../../../store/readHelpers/SessionReader';
import sessionConstants from '../../../../constants/SessionConstants';
import styles from './extendedTextInteraction.scss';
import { t } from '../../../../services/i18nService';
import wordCountService from '../../../../services/WordCountService';

import wordCountTextStyles from './plainText/TextCounter/WordCountText.scss';
import { countWords } from './ckeditor/plugins/wordcount/wordCountPlugin';

class ExtendedTextPrint extends React.PureComponent {
    static propTypes = {
        handleInteractionReady: PropTypes.func.isRequired,
        isHtml: PropTypes.bool,
        userData: PropTypes.string.isRequired,
        prompt: PropTypes.string,
        viewMedia: PropTypes.string.isRequired,
        showWordCountOption: PropTypes.bool,
    };

    componentDidMount() {
        const { isHtml, userData } = this.props;
        if (isHtml) {
            // userData might not be painted when using dangerouslySetInnerHTML on componentDidMount, therefore
            // adding a little buffer. Images can be inserted as base64 using the drawing tool. Adding even more
            // buffer for this.
            // TODO add proper ready handling of drawing tool images and consider changing this for chrome headless
            const hasImages = userData && userData.indexOf('<img') > -1;
            const delay = hasImages ? 3000 : 1000;
            setTimeout(() => {
                this.props.handleInteractionReady(true);
            }, delay);
        } else {
            this.props.handleInteractionReady(true);
        }
    }

    render() {
        const { isHtml, userData, prompt, viewMedia, showWordCountOption } = this.props;
        const printStyle = sessionReader.getPrintParam('printStyle', sessionConstants.PRINT_STYLE_STANDARD);
        const isPaperBased = sessionReader.isPrintStylePaperBased();

        const wordCountElement = wordCountService.shouldShowWordCount(showWordCountOption) &&
            <p className={wordCountTextStyles.wordCountText}>{t('essay.wordCount', { words: countWords(userData) })}</p>;

        if (isHtml) {
            return (
                <div className="interaction allowed-break-inside">
                    {!isPaperBased && <Prompt model={prompt} />}
                    <div
                        className={`${styles.textWrapper} ${viewMedia} print-style-${printStyle} html`}
                        dangerouslySetInnerHTML={{ __html: userData }}
                    />
                    {!isPaperBased ? wordCountElement : null}
                </div>
            );
        }

        return (
            <div className="interaction allowed-break-inside">
                {!isPaperBased && <Prompt model={prompt} />}
                <div className={`${styles.textWrapper} ${viewMedia} print-style-${printStyle} plainText`}>
                    {userData}
                </div>
                {!isPaperBased ? wordCountElement : null}
            </div>
        );
    }
}

export default ExtendedTextPrint;
